module.exports = __webpack_public_path__ + "static/media/mobile.8385359e.jpeg";